/* Cart Upsell – "You Might Also Like These"
 * Custom theme replacement for the Selleasy sidecart block.
 * Reads product data from #cart-upsell-data, picks products ONCE per page load
 * (so a page refresh shows a fresh random group/order), and re-injects the
 * carousel into #CartFlyoutUpsellCustom after every cart re-render.
 */
(function () {
  'use strict';

  let picked = null; // products selected once per page load
  let cfg = null;
  let widget = null; // built once, then re-attached after each cart re-render

  function readData() {
    const el = document.getElementById('cart-upsell-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  const ROTATION_KEY = 'cartUpsellRotation';

  // Variant B: pick a group index with no repeats until every group has been
  // shown, then reset. State persists across page reloads via localStorage,
  // keyed by a signature of the current group set (resets if groups change).
  function rotateGroupIndex(groups) {
    const ids = groups.map(function (g) { return g.id; });
    const sig = ids.join('|');
    let state = null;
    try { state = JSON.parse(localStorage.getItem(ROTATION_KEY) || 'null'); } catch (e) {}
    if (!state || state.sig !== sig || !Array.isArray(state.shown)) state = { sig: sig, shown: [] };

    const candidates = [];
    for (let i = 0; i < groups.length; i++) {
      if (state.shown.indexOf(ids[i]) === -1) candidates.push(i);
    }
    if (!candidates.length) { // all shown -> reset and start over
      state.shown = [];
      for (let j = 0; j < groups.length; j++) candidates.push(j);
    }
    const idx = candidates[Math.floor(Math.random() * candidates.length)];
    state.shown.push(ids[idx]);
    try { localStorage.setItem(ROTATION_KEY, JSON.stringify(state)); } catch (e) {}
    return idx;
  }

  function selectProducts(data) {
    const groups = (data.groups || []).filter(function (g) { return g && g.products && g.products.length; });
    if (!groups.length) return [];
    const source = cfg.source || (data.config && data.config.source) || 'collection';

    let idx;
    if (source === 'metaobject' && groups.length > 1) {
      idx = rotateGroupIndex(groups); // new random group each reload, no repeats until exhausted
    } else {
      idx = Math.floor(Math.random() * groups.length);
    }

    const products = groups[idx].products.slice();
    // Random subset/order each reload (Variant A relies on this for fresh products).
    if (cfg.shuffle) shuffle(products);
    return products.slice(0, cfg.count || 6);
  }

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function cardHTML(p, index) {
    let price = '<span class="cu-now">' + esc(p.price) + '</span>';
    if (p.on_sale && p.compare) price += '<s>' + esc(p.compare) + '</s>';
    const img = p.image ? '<img src="' + encodeURI(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    const handle = esc(p.handle || '');
    const variant = esc(p.variantId != null ? String(p.variantId) : '');
    // Details opens the theme Quick Shop popup (handled in initQuickShop below).
    // data-cu-variant carries the variant whose image is shown so the popup
    // pre-selects that color. href is the graceful no-JS fallback.
    const btn = cfg.showButton
      ? '<a class="cu-btn" data-cu-handle="' + handle + '" data-cu-variant="' + variant + '" href="' + encodeURI(p.url) + '">' + esc(cfg.buttonLabel || 'Details') + '</a>'
      : '';
    return '<div class="swiper-slide cu-card" data-cu-index="' + index + '">'
      +   '<a class="cu-img" href="' + encodeURI(p.url) + '">' + img + '</a>'
      +   '<div class="cu-name">' + esc(p.title) + '</div>'
      +   '<div class="cu-price">' + price + '</div>'
      +   btn
      + '</div>';
  }

  function widgetHTML(items) {
    const slides = items.map(cardHTML).join('');
    return '<div class="cart-upsell">'
      +   '<div class="cu-head">'
      +     '<span class="cu-title">' + esc(cfg.title || '') + '</span>'
      +     '<div class="cu-nav">'
      +       '<button type="button" class="cu-prev" aria-label="Previous"><svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 7L10 12L15 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
      +       '<button type="button" class="cu-next" aria-label="Next"><svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 7L15 12L10 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="swiper cart-upsell-swiper"><div class="swiper-wrapper">' + slides + '</div></div>'
      + '</div>';
  }

  function initSwiper(root) {
    const el = root.querySelector('.cart-upsell-swiper');
    if (!el || !window.Swiper) return false;
    if (el.swiper) { el.swiper.destroy(true, true); }
    new window.Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        prevEl: root.querySelector('.cu-prev'),
        nextEl: root.querySelector('.cu-next')
      }
    });
    return true;
  }

  // Self-mounting: append our container to the cart products list (which app.js
  // rebuilds on every cart render — patchUtilities re-injects us afterwards).
  function getMount() {
    const products = document.getElementById('CartFlyoutProducts');
    if (!products) return null;
    let mount = document.getElementById('CartFlyoutUpsellCustom');
    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'CartFlyoutUpsellCustom';
      mount.className = 'cart-upsell-block';
      products.appendChild(mount);
    }
    return mount;
  }

  function render() {
    const holder = getMount();
    if (!holder) return;
    const data = readData();
    if (!data || !data.config || !data.config.enable) { holder.innerHTML = ''; return; }
    cfg = data.config;
    if (picked === null) picked = selectProducts(data);
    if (!picked.length) { holder.innerHTML = ''; return; }
    // Re-attach instead of rebuilding: re-creating Swiper reflows the whole flyout.
    if (!widget) {
      holder.innerHTML = widgetHTML(picked);
      // Only cache once Swiper is up, so a late-loading Swiper still gets a retry.
      if (initSwiper(holder)) widget = holder.firstElementChild;
    } else if (widget.parentNode !== holder) {
      holder.appendChild(widget);
    }
    observeView(holder);
  }

  // app.js rebuilds #CartFlyoutProducts on every cart change —
  // re-inject our widget after each renderCartFlyout call.
  function patchUtilities(attempts) {
    attempts = attempts || 0;
    if (attempts > 100) return; // give up after ~5s
    if (typeof Utilities === 'undefined' || typeof Utilities.renderCartFlyout !== 'function') {
      setTimeout(function () { patchUtilities(attempts + 1); }, 50);
      return;
    }
    if (!Utilities.__upsellPatched) {
      Utilities.__upsellPatched = true;
      const _orig = Utilities.renderCartFlyout.bind(Utilities);
      Utilities.renderCartFlyout = function (cart, openFlyout) {
        _orig(cart, openFlyout);
        render();
      };
    }
    render(); // ensure a paint after the patch is in place
  }

  /* ----------------------------------------------------------------
   * GA4 analytics bridge. Publishes namespaced custom events that the
   * "YML Upsell -> GA4" custom pixel (Settings > Customer events) forwards
   * to Google Analytics 4 via the Measurement Protocol. The pixel owns the
   * GA config + list/source naming; here we only emit product data:
   *   liveclothing:upsell_view_list   - block impression (once per page load)
   *   liveclothing:upsell_select_item - click on a product (image or Details)
   *   liveclothing:upsell_add_to_cart - product added via the widget's Quick Shop
   * Purchase attribution is done entirely in the pixel, by reading the
   * `_cart_upsell_discount` line-item property on checkout_completed.
   * ---------------------------------------------------------------- */
  function analyticsCurrency() {
    if (cfg && cfg.currency) return cfg.currency;
    const d = readData();
    return (d && d.config && d.config.currency) || undefined;
  }

  function pub(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics unavailable - ignore */ }
  }

  function toAmount(v) {
    const n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  // Minimal GA4 item shape from a picked product (the shown variant).
  function itemFromPicked(p, index) {
    if (!p) return null;
    const it = {
      item_id: p.variantId != null ? String(p.variantId) : '',
      item_name: p.title || '',
      price: toAmount(p.priceAmount),
      quantity: 1
    };
    if (index != null) it.index = index;
    return it;
  }

  let viewFired = false;
  let viewObserver = null;

  function fireViewList() {
    if (viewFired || !picked || !picked.length) return;
    viewFired = true;
    if (viewObserver) { viewObserver.disconnect(); viewObserver = null; }
    const items = [];
    for (let i = 0; i < picked.length; i++) {
      const it = itemFromPicked(picked[i], i);
      if (it) items.push(it);
    }
    if (items.length) pub('liveclothing:upsell_view_list', { currency: analyticsCurrency(), discountProp: discountProp(), items: items });
  }

  // Fire one view_item_list impression the first time the block is visible.
  // render() runs after every cart re-render (which destroys and recreates the
  // mount), so re-target the observer at the LIVE mount each time; `viewFired`
  // keeps it to a single impression per page load.
  function observeView(root) {
    if (viewFired || !root) return;
    if (!('IntersectionObserver' in window)) { fireViewList(); return; }
    if (viewObserver) viewObserver.disconnect();
    viewObserver = new IntersectionObserver(function (entries) {
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { fireViewList(); return; }
      }
    }, { threshold: 0.3 });
    viewObserver.observe(root);
  }

  // select_item - click on a product card's image or Details button.
  function onSelectItem(e) {
    const link = e.target && e.target.closest ? e.target.closest('.cu-img, .cu-btn') : null;
    if (!link) return;
    const card = link.closest('.cu-card');
    if (!card || !card.closest('#CartFlyoutUpsellCustom')) return;
    const idx = parseInt(card.getAttribute('data-cu-index'), 10);
    const it = itemFromPicked((picked && !isNaN(idx)) ? picked[idx] : null, isNaN(idx) ? null : idx);
    if (it) pub('liveclothing:upsell_select_item', { currency: analyticsCurrency(), discountProp: discountProp(), items: [it] });
  }

  // Publish upsell_add_to_cart from the actual /cart/add.js response so the
  // reported variant/price/qty match exactly what was added.
  function reportAddToCart(respPromise) {
    if (!respPromise || typeof respPromise.then !== 'function') return;
    respPromise.then(function (r) {
      try {
        r.clone().json().then(function (data) {
          const added = data && data.items ? data.items[0] : data;
          if (!added) return;
          const cents = typeof added.final_price === 'number' ? added.final_price : (typeof added.price === 'number' ? added.price : 0);
          const price = cents / 100;
          const qty = added.quantity || 1;
          pub('liveclothing:upsell_add_to_cart', {
            currency: analyticsCurrency(),
            value: price * qty,
            discountProp: discountProp(),
            items: [{
              item_id: String(added.variant_id || added.id || ''),
              item_name: added.product_title || added.title || '',
              price: price,
              quantity: qty
            }]
          });
        }).catch(function () {});
      } catch (e) { /* ignore */ }
    }).catch(function () {});
  }

  /* ----------------------------------------------------------------
   * Quick Shop: the "Details" button opens the theme's Quick Shop popup
   * (#quick-add-popup) for the product, pre-selecting the color of the
   * variant whose image is shown in the widget. Self-contained — no
   * dependency on the Selleasy lb-action-product interceptor.
   * ---------------------------------------------------------------- */
  const productCache = Object.create(null);

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    const p = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    productCache[handle] = p;
    p.catch(function () { delete productCache[handle]; });
    return p;
  }

  // Build the JSON the popup expects (mirrors custom.js ensureProductDataScript),
  // pre-selecting `variantId` when provided so the popup opens on that color.
  function ensureProductDataScript(product, variantId) {
    const id = 'quick-add-product-data-' + product.id;
    if (document.getElementById(id)) return;

    let selected = null;
    if (variantId) {
      for (let v = 0; v < product.variants.length; v++) {
        if (String(product.variants[v].id) === String(variantId)) { selected = product.variants[v]; break; }
      }
    }
    if (!selected) {
      for (let a = 0; a < product.variants.length; a++) {
        if (product.variants[a].available) { selected = product.variants[a]; break; }
      }
    }
    if (!selected) selected = product.variants[0];

    const media = (product.media || []).map(function (m) {
      return { src: (m.preview_image && m.preview_image.src) || m.src || '', alt: m.alt || '' };
    });
    const inventory = product.variants.map(function (v) {
      return { id: v.id, inventory_quantity: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0 };
    });
    const optionNames = (product.options || []).map(function (o) {
      if (typeof o === 'string') return o;
      if (o && typeof o.name === 'string') return o.name;
      return String(o);
    });

    const payload = {
      product: {
        id: product.id, handle: product.handle, title: product.title, price: product.price,
        options: optionNames, variants: product.variants, media: media
      },
      selected_or_first_available_variant: selected,
      variants_inventory: inventory
    };
    const script = document.createElement('script');
    script.type = 'application/json';
    script.id = id;
    script.textContent = JSON.stringify(payload);
    document.body.appendChild(script);
  }

  function clearLoading(el) { if (el && el.classList) el.classList.remove('loading'); }

  function waitForPopupThenClear(el) {
    const popup = document.getElementById('quick-add-popup');
    if (!popup) { setTimeout(function () { clearLoading(el); }, 600); return; }
    if (popup.classList.contains('_is-visible')) { clearLoading(el); return; }
    const obs = new MutationObserver(function () {
      if (popup.classList.contains('_is-visible')) { clearLoading(el); obs.disconnect(); }
    });
    obs.observe(popup, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { obs.disconnect(); clearLoading(el); }, 5000);
  }

  function openQuickShop(handle, variantId, loadingEl) {
    fetchProduct(handle).then(function (product) {
      ensureProductDataScript(product, variantId);
      const fake = document.createElement('button');
      fake.className = 'item-quick-add__button';
      fake.setAttribute('data-product-id', String(product.id));
      // The popup derives the pre-selected color from this variant (option2).
      if (variantId) fake.setAttribute('data-current-variant-id', String(variantId));
      fake.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
      document.body.appendChild(fake);

      let dispatched = false;
      try {
        if (typeof quickAddPopupInit === 'function') { quickAddPopupInit(fake); dispatched = true; }
      } catch (e) {}
      if (!dispatched) { try { fake.click(); } catch (e) {} }

      setTimeout(function () { if (fake.parentNode) fake.parentNode.removeChild(fake); }, 0);
      waitForPopupThenClear(loadingEl);
    }).catch(function () { clearLoading(loadingEl); });
  }

  function quickShopAvailable() {
    try { return typeof quickAddPopupInit === 'function'; } catch (e) { return false; }
  }

  /* ----------------------------------------------------------------
   * Discount tracking: products added through this widget get a
   * configurable line-item property (default "_cart_upsell_discount").
   * A fetch() wrapper injects it into the /cart/add.js that follows a
   * Details click, then disarms (one-shot).
   * ---------------------------------------------------------------- */
  let pending = null;
  const PENDING_TTL = 10 * 60 * 1000;

  function discountProp() {
    if (cfg && cfg.discountProp) return cfg.discountProp;
    const d = readData();
    return (d && d.config && d.config.discountProp) || '';
  }

  function armDiscount() {
    const prop = discountProp();
    if (!prop) return;
    const props = {};
    props[prop] = 'true';
    pending = { props: props, t: Date.now() };
  }

  function pendingValid() {
    return pending && (Date.now() - pending.t) < PENDING_TTL;
  }

  // Let other trackers (shop-all-color-analytics) skip the adds this block owns.
  window.__cartUpsellPending = pendingValid;

  function injectProps(init, props) {
    if (!init || !init.body) return null;
    const body = init.body;
    if (typeof body === 'string') {
      if (body.replace(/^\s+/, '').charAt(0) !== '{') return null;
      let obj;
      try { obj = JSON.parse(body); } catch (e) { return null; }
      obj.properties = obj.properties || {};
      for (const k in props) { if (!(k in obj.properties)) obj.properties[k] = props[k]; }
      const ni = {};
      for (const key in init) ni[key] = init[key];
      ni.body = JSON.stringify(obj);
      return ni;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      for (const p in props) { body.append('properties[' + p + ']', props[p]); }
      return init;
    }
    return null;
  }

  function patchFetch() {
    if (!window.fetch || window.__cartUpsellFetchPatched) return;
    window.__cartUpsellFetchPatched = true;
    const _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        const url = (typeof input === 'string') ? input : (input && input.url) || '';
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (pendingValid() && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          const ni = injectProps(init, pending.props);
          pending = null; // one-shot: never tag the One Tree / subsequent adds
          if (ni) {
            const resp = _fetch(input, ni);
            reportAddToCart(resp); // GA4 upsell_add_to_cart from the real response
            return resp;
          }
        }
      } catch (e) { /* fall through */ }
      return _fetch(input, init);
    };
  }

  // Single delegated handler: open Quick Shop + arm the discount.
  let quickShopTrigger = null;

  function onDetailsClick(e) {
    const btn = e.target && e.target.closest ? e.target.closest('.cu-btn') : null;
    if (!btn || !btn.closest('#CartFlyoutUpsellCustom')) return;
    if (!quickShopAvailable()) return; // let the href navigate to the PDP
    e.preventDefault();
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');
    armDiscount();
    quickShopTrigger = btn;
    openQuickShop(btn.getAttribute('data-cu-handle') || '', btn.getAttribute('data-cu-variant') || '', btn);
  }

  function observePopupClose() {
    const popup = document.getElementById('quick-add-popup');
    if (!popup || !window.MutationObserver) return;
    // Clear only on a real close (visible -> hidden). The popup adds its
    // active class BEFORE `_is-visible` on open, so a naive "is _is-visible
    // absent?" check would wipe `pending` the instant the popup starts opening.
    let wasVisible = popup.classList.contains('_is-visible');
    new MutationObserver(function () {
      const vis = popup.classList.contains('_is-visible');
      if (wasVisible && !vis) {
        pending = null;
        // the popup is opened from a throwaway trigger, so it cannot hand focus back itself
        const active = document.activeElement;
        if (quickShopTrigger && document.contains(quickShopTrigger) &&
            (!active || active === document.body || popup.contains(active))) {
          quickShopTrigger.focus();
        }
        quickShopTrigger = null;
      }
      wasVisible = vis;
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    render();
    patchUtilities();
    observePopupClose();
  }

  patchFetch(); // install immediately so the wrapper beats other scripts
  document.addEventListener('click', onDetailsClick);
  document.addEventListener('click', onSelectItem);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
